import React, { useState } from "react";
import cx from "classnames";
import styles from "./gaHoverTooltip.module.scss";
import {
  TooltipArrowPosition,
  TooltipPosition,
} from "../../../../assets/globalConstants";

type IGaHoverTooltipProps = {
  label?: React.ReactNode | string;
  info: string;
  position?: TooltipPosition;
  positionArrowDirection?: TooltipArrowPosition;
  noArrow?: boolean;
  className?: string;
  delay?: number;
};

const GaHoverTooltip: React.FC<IGaHoverTooltipProps> = (props) => {
  const {
    label,
    info,
    position,
    positionArrowDirection,
    noArrow,
    className,
    delay,
  } = props;

  let timeout;

  const [hover, setHover] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setHover(true);
    }, delay || 200);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setHover(false);
  };

  const getTooltipPositionClass = () => {
    let positionClass = styles.positionTop;

    if (position) {
      switch (position) {
        case "right":
          positionClass = styles.positionRight;
          break;

        case "bottom":
          positionClass = styles.positionBottom;
          break;
        case "left":
          positionClass = styles.positionLeft;
          break;
        default:
          positionClass = styles.positionTop;
      }
    }

    return positionClass;
  };

  const getTooltipArrowDirection = () => {
    let arrowDirectionClass = "";

    if (positionArrowDirection) {
      switch (positionArrowDirection) {
        case "right":
          arrowDirectionClass = styles.directionRight;
          break;
        case "left":
          arrowDirectionClass = styles.directionLeft;
          break;
        default:
          arrowDirectionClass = "";
      }
    }

    return arrowDirectionClass;
  };

  const positionClass = getTooltipPositionClass();
  const arrowDirectionClass = getTooltipArrowDirection();

  return (
    <div
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
      className={`${styles.gaTooltip__container} ${
        className ? className : ""
      }`}>
      <>
        <div className={`${styles.textTooltipContainer}`}>
          {label}
          {hover && (
            <div
              className={`${
                styles.gaTooltip__info
              } ${positionClass} ${arrowDirectionClass} ${
                noArrow ? styles.noArrow : ""
              } ${cx("bodyRegularXS neutral100")}`}>
              {info}
            </div>
          )}
        </div>
      </>
    </div>
  );
};

export default GaHoverTooltip;
